<template>
  <div id="airplane-progress-container">
    <div id="airplane-progress" class="w-100">
      <div class="progress">
        <div class="progress-bar bg-primary" role="progressbar" :style="`width: ${progress}%`" :aria-valuenow="progress" aria-valuemin="0" aria-valuemax="100"></div>
      </div>
      <img ref="airplane" id="airplane-vector" :src="require('./../../assets/img/plane.png')" :style="`left:${(progress-2)}%`" />
    </div>
  </div>
</template>

<script>
import anime from 'animejs'

export default {
  name: 'airplane-progress',
  props: {
    progress: Number,
    runAnim: undefined
  },
  watch: {
    progress: function (newProgress) {
      // this.runAnim.play()
    }
  },
  mounted () {
    anime({
      targets: this.$refs['airplane'],
      translateY: [
        '-50%', '-=10'
      ],
      direction: 'alternate',
      duration: 1000,
      easing: 'linear',
      loop: true
    })
    // this.runAnim = anime({
    //   targets: this.$refs['airplane'],
    //   rotate: [
    //     '+=90deg'
    //   ],
    //   direction: 'alternate',
    //   duration: 10000,
    //   easing: 'linear',
    //   autoplay: false
    // })
  }
}
</script>

<style lang="scss">

  @import "~bootstrap/scss/functions";
  @import '~bootstrap/scss/variables';
  @import '@/assets/scss/_variables.scss';

  #airplane-progress-container{
    height: 25px;
    background: $skyColor;
    @media screen and (max-width: map-get($container-max-widths, sm)) {
      height: 8px;
      width: 10%;
    }
  }

  #airplane-progress {
    position: absolute;
    top: 0px;
    .progress {
      height: 8px;
      @media screen and (max-width: map-get($container-max-widths, sm)) {
        height: 6px;
      }
    }
  }

  #airplane-vector{
    height: 60px;
    position: absolute;
    z-index: 2;
    top: 4px;
    // transform: translateY(-50%) rotate(90deg);
    transform: translateY(-60%);
    transition: left 0.6s ease;
    @media screen and (max-width: map-get($container-max-widths, sm)) {
      height: 40px;
    }
  }
</style>
